var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("sidebar-array-view", {
    attrs: { title: "EQUIPMENT TAGS", array: _vm.tags, icon: "mdi-tag" }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }